import { Component, OnInit } from '@angular/core';
import { EncuestaService } from '../../../services/encuesta.service';
import { EncuestaDTO } from '../../../dto/encuesta/encuesta.dto';
import { PreguntaDTO } from '../../../dto/encuesta/preguntas.dto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RespuestaEncuestaDto } from '../../../dto/encuesta/respuesta-encuesta.dto';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OpcionRespuestaDto } from '../../../dto/encuesta/opcion-respuesta.dto';

@Component({
  selector: 'app-encuesta-satisfaccion',
  templateUrl: './encuesta-satisfaccion.component.html',
  styleUrl: './encuesta-satisfaccion.component.scss',
})
export class EncuestaSatisfaccionComponent implements OnInit {
  encuestaForm!: FormGroup;
  encuesta!: EncuestaDTO;
  preguntas: PreguntaDTO[] = [];
  respuestasEncuesta: RespuestaEncuestaDto[] = [];
  idEncuestaUsuario!: number;

  constructor(
    private activatedRoute: ActivatedRoute,
    private encuestaService: EncuestaService,
    private modalService: AlertaModalService,
    private fb: FormBuilder,
    private router: Router
  ) {
    this.activatedRoute.params.subscribe((params: any) => {
      this.idEncuestaUsuario = params['id-encuesta'];
    });
  }

  ngOnInit(): void {
    this.encuestaService
      .getEncuentaByid(this.idEncuestaUsuario)
      .subscribe(resp => {
        this.encuesta = resp;
        this.preguntas = this.encuesta.Preguntas?.filter(p => !!p.Estado) || [];
        this.crearForm();
      });
  }

  crearForm(): void {
    const controls: { [key: string]: any } = {};
    this.preguntas.forEach((pregunta, index) => {
      controls['pregunta' + index] = this.fb.control('', Validators.required);
    });

    this.encuestaForm = this.fb.group(controls);
  }

  onSubmit(): void {
    this.respuestasEncuesta = [];
    const valores = Object.values(this.encuestaForm.value) as (
      | OpcionRespuestaDto
      | string
      | null
    )[];

    this.preguntas.forEach((pregunta, index) => {
      const valor = valores[index];

      const respuesta: RespuestaEncuestaDto = {
        Texto_Pregunta: pregunta.Descripcion,
        Respuesta:
          typeof valor === 'object' && valor !== null && 'Descripcion' in valor
            ? (valor as OpcionRespuestaDto).Descripcion
            : (valor as string | null),
        Respuesta_Texto: pregunta.Descripcion,
      };

      this.respuestasEncuesta.push(respuesta);
    });

    this.encuestaService
      .guardarRespuestas(this.idEncuestaUsuario, this.respuestasEncuesta)
      .subscribe(() => {
        this.modalService
          .exito('Encuesta finalizada', 'Gracias por diligenciar la encuesta.')
          .then(() => {
            this.goHome();
          });
      });
  }

  goHome() {
    this.router.navigate(['/login']);
  }

  capitalizarFrase(text: string): string {
    if (!text) return '';
    text = text.trim().toLowerCase();
    const match = text.match(/^([¿¡]?)(\w)(.*)/);

    if (!match) return text;
    const [, signo, primeraLetra, resto] = match;
    return `${signo}${primeraLetra.toUpperCase()}${resto}`;
  }

}
